module.exports = __webpack_public_path__ + "static/media/thumb2-2.d2756fdc.png";